import { render, staticRenderFns } from "./alt-auto-table.vue?vue&type=template&id=1cb17ec1&"
import script from "./alt-auto-table.vue?vue&type=script&lang=js&"
export * from "./alt-auto-table.vue?vue&type=script&lang=js&"
import style0 from "./alt-auto-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports